import * as actionTypes from '../../constants/actionTypes';
import { CALL_PRIVATE_API } from '../../middleware/api';

import { teamSchema } from '../../schemas';
import { GET, POST, PUT } from '../../constants/requestMethods';

export const loadTeams = () => (dispatch, getState) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_TEAMS_REQUEST,
        actionTypes.GET_TEAMS_SUCCESS,
        actionTypes.GET_TEAMS_FAILURE,
      ],
      endpoint: `/teams`,
      schema: [teamSchema],
      requestMethod: GET,
    },
  });
};

export const loadMyTeams = () => (dispatch, getState) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_MY_TEAMS_REQUEST,
        actionTypes.GET_MY_TEAMS_SUCCESS,
        actionTypes.GET_MY_TEAMS_FAILURE,
      ],
      endpoint: `/teams`,
      schema: [teamSchema],
      requestMethod: GET,
      payload: {
        access_role: 'member',
      },
    },
  });
};

export const addTeam = (info) => (dispatch, getState) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.ADD_TEAM_REQUEST,
        actionTypes.ADD_TEAM_SUCCESS,
        actionTypes.ADD_TEAM_FAILURE,
      ],
      endpoint: `/teams`,
      schema: teamSchema,
      requestMethod: POST,
      payload: info,
    },
  });
};

export const updateTeamMembers = (id, newInfo) => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.UPDATE_TEAM_MEMBERS_REQUEST,
        actionTypes.UPDATE_TEAM_MEMBERS_SUCCESS,
        actionTypes.UPDATE_TEAM_MEMBERS_FAILURE,
      ],
      endpoint: `/teams/${id}/members`,
      requestMethod: POST,
      payload: {
        members: newInfo.members,
      },
    },
  }).then(() => {
    dispatch(loadTeams());
  });
};

export const updateTeamInfo =
  (id, newInfo = {}) =>
  (dispatch, getState) => {
    return dispatch({
      [CALL_PRIVATE_API]: {
        types: [
          actionTypes.UPDATE_TEAM_INFO_REQUEST,
          actionTypes.UPDATE_TEAM_INFO_SUCCESS,
          actionTypes.UPDATE_TEAM_INFO_FAILURE,
        ],
        endpoint: `/teams/${id}`,
        schema: teamSchema,
        requestMethod: PUT,
        payload: newInfo,
      },
    }).then(() => {
      dispatch(updateTeamMembers(id, newInfo));
    });
  };
